import { http } from "../../utils/config";

const mapSmsAPI = {
    getMapSmss: (params = {}) => {
        const {
            page = 1,
            per_page = 15,
            search = "",
            status = "",
            sort_by = "created_at",
            sort_order = "desc",
        } = params;

        const queryParams = new URLSearchParams({
            page: page.toString(),
            per_page: per_page.toString(),
            sort_by,
            sort_order,
            ...(search && { search }),
            ...(status !== "" && { status }),
        });

        return http.get(`/api/v1/sms/map?${queryParams}`);
    },

    getAllParamsSms: () => {
        return http.get(`/api/v1/sms/message-params`);
    },

    // Create new
    createMapSms: (mapSmsData) => {
        return http.post("/api/v1/sms/map", mapSmsData);
    },

    // Update
    updateMapSms: (id, mapSmsData) => {
        return http.put(`/api/v1/sms/map/${id}`, mapSmsData);
    },

    deleteMapSms: (id) => {
        return http.delete(`/api/v1/sms/map/${id}`);
    },

    getHistories: (params = {}) => {
        const {
            page = 1,
            per_page = 15,
            search = "",
            status = "",
            sort_by = "created_at",
            sort_order = "desc",
        } = params;

        const queryParams = new URLSearchParams({
            page: page.toString(),
            per_page: per_page.toString(),
            sort_by,
            sort_order,
            ...(search && { search }),
            ...(status !== "" && { status }),
        });

        return http.get(`/api/v1/logs/sms?${queryParams}`);
    },
};

// Error handling wrapper
export const withErrorHandling = (apiFunction) => {
    return async (...args) => {
        try {
            const response = await apiFunction(...args);
            return response;
        } catch (error) {
            console.error("API Error:", error);

            // Handle different types of errors
            if (error.response) {
                // Server responded with error status
                const { status, data } = error.response;
                switch (status) {
                    case 400:
                        throw new Error(data.message || "Dữ liệu không hợp lệ");
                    case 401:
                        throw new Error("Bạn cần đăng nhập để thực hiện thao tác này");
                    case 403:
                        throw new Error("Bạn không có quyền thực hiện thao tác này");
                    case 404:
                        throw new Error("Không tìm thấy thông tin");
                    case 422:
                        throw new Error(data.message || "Dữ liệu không hợp lệ");
                    case 500:
                        throw new Error(data.message || "Lỗi server, vui lòng thử lại sau");
                    default:
                        throw new Error(data.message || "Đã có lỗi xảy ra");
                }
            } else if (error.request) {
                // Network error
                throw new Error("Không thể kết nối đến server");
            } else {
                // Other error
                throw new Error(error.message || "Đã có lỗi xảy ra");
            }
        }
    };
};

// Wrapped API functions with error handling
export const mapSmsAPIWithErrorHandling = {
    getMapSmss: withErrorHandling(mapSmsAPI.getMapSmss),
    getAllParamsSms: withErrorHandling(mapSmsAPI.getAllParamsSms),
    createMapSms: withErrorHandling(mapSmsAPI.createMapSms),
    updateMapSms: withErrorHandling(mapSmsAPI.updateMapSms),
    deleteMapSms: withErrorHandling(mapSmsAPI.deleteMapSms),
    getHistories: withErrorHandling(mapSmsAPI.getHistories),
};

export default mapSmsAPI;
